/**
 * Checks if the input password has whitespace
 *
 * @param {string} password
 * @returns {boolean}
 */
export const isWhiteSpace = (password) => {
  const pattern = /(\s)+/g
  return pattern.test(password)
}

/**
 * Checks if the input password length is valid
 *
 * @param {string} password
 * @returns {boolean}
 */
export const isValidPasswordLength = (password) => {
  if (password.length >= 8 && password.length < 64) {
    return true
  } else {
    return false
  }
}

/**
 * Checks if the input password pattern is valid
 *
 * @param {string} password
 * @returns {boolean}
 */
export const isValidPasswordPattern = (password) => {
  const specialCharPattern = new RegExp(/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/) // eslint-disable-line
  const numericAndUpperCaseAndLowerCaseCharPattern = new RegExp(
    '^(?=.*?[0-9])(?=.*?[A-Z])(?=.*?[a-z])'
  )

  const isIncludeSpecialChar = specialCharPattern.test(password)
  const isIncludeNumericAndUpperAndLowerChar =
    numericAndUpperCaseAndLowerCaseCharPattern.test(password)

  if (isIncludeSpecialChar && isIncludeNumericAndUpperAndLowerChar) {
    return true
  } else {
    return false
  }
}

/**
 * Checks if User data is valid
 *
 * @param {string} password
 * @param {string} email
 * @param {string} companyName
 * @param {string} name
 * @returns {boolean}
 */
export const hasUserData = (password, email, companyName, name) => {
  const lowerPassword = password.toLowerCase()
  const lowerEmail = email.toLowerCase()
  const lowerCompanyName = companyName.toLowerCase()
  const lowerName = name.toLowerCase()
  const passwordRemoveNumuric = lowerPassword.replace(/[0-9]/g, '')
  const passwordRemoveSpecial = passwordRemoveNumuric.replace(
    /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/g, // eslint-disable-line
    ''
  )

  var isHasUserData = false
  if (passwordRemoveSpecial != '') {
    isHasUserData =
      lowerEmail.includes(passwordRemoveSpecial) ||
      lowerCompanyName.includes(passwordRemoveSpecial) ||
      lowerName.includes(passwordRemoveSpecial) ||
      lowerEmail.includes(lowerPassword) ||
      lowerCompanyName.includes(lowerPassword) ||
      lowerName.includes(lowerPassword)
  }
  return isHasUserData
}

/**
 * Checks if password sequence a valid number
 *
 * @param {string} password
 * @returns {boolean}
 */
export const isSequenceNumber = (password) => {
  // number not sequence > 2
  password = password.toLowerCase()
  var passwordRemovecharactor = password.replace(/[a-z]/g, '')
  var arrPassword = passwordRemovecharactor.split('')
  var countSequence = 0
  for (var i = 0; i < arrPassword.length - 1; ++i) {
    if (parseInt(arrPassword[i]) + 1 == parseInt(arrPassword[i + 1])) {
      countSequence += 1
    } else {
      countSequence = 0
    }
    if (countSequence >= 2) {
      return true
    }
  }

  return false
}

/**
 * Checks if password is repeated
 *
 * @param {string} password
 * @returns {boolean}
 */
export const isRepeated = (password) => {
  // charatec not repeat > 2 characters
  var arrPassword = password.split('')
  var countRepeate = 0
  for (var i = 0; i < arrPassword.length - 1; ++i) {
    if (arrPassword[i] == arrPassword[i + 1]) {
      countRepeate += 1
    } else {
      countRepeate = 0
    }
    if (countRepeate >= 2) {
      return true
    }
  }
  return false
}

/**
 * Gets invalid message based on error
 *
 * @param {string} password
 * @param {string} email
 * @param {string} companyName
 * @param {string} name
 * @returns {string}
 */
export const getInValidMessage = (password, email, companyName, name) => {
  if (isWhiteSpace(password)) {
    return 'Password cannot contain any spaces.'
  } else if (!isValidPasswordLength(password)) {
    return 'Password must be at least 8 - 64 characters.'
  } else if (!isValidPasswordPattern(password)) {
    return 'Password must include a number, symbol, upper and lowercase letter.'
  } else if (isSequenceNumber(password) || isRepeated(password)) {
    return 'Password may not contain repetitive or sequential characters.'
  } else if (email != undefined && companyName != undefined && name != undefined) {
    if (hasUserData(password, email, companyName, name)) {
      return 'Password may not contain parts from your account information.'
    } else {
      return ''
    }
  } else {
    return ''
  }
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/libs/text-validation/index.js